module.exports = __webpack_public_path__ + "static/media/15.7cf32761.jpg";